var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8593_1250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.24 49.48C42.0751 49.48 52.48 39.0751 52.48 26.24C52.48 13.4049 42.0751 3 29.24 3C16.4049 3 6 13.4049 6 26.24C6 39.0751 16.4049 49.48 29.24 49.48Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7789 20.3267C38.0648 20.6427 37.3074 20.8504 36.5319 20.9427C37.3486 20.4542 37.9599 19.6855 38.2519 18.7797C37.4838 19.2354 36.6433 19.556 35.7669 19.7277C35.2301 19.1557 34.5337 18.7582 33.7682 18.5868C33.0027 18.4154 32.2033 18.4779 31.4738 18.7664C30.7443 19.0548 30.1182 19.5558 29.6769 20.2044C29.2356 20.853 28.9994 21.6193 28.9989 22.4037C28.9983 22.7039 29.0319 23.0032 29.0989 23.2957C27.544 23.2176 26.023 22.8133 24.6344 22.1092C23.2458 21.4051 22.0209 20.4169 21.0389 19.2087C20.5386 20.0698 20.3853 21.0892 20.6101 22.0593C20.8349 23.0294 21.4209 23.8775 22.2489 24.4307C21.6279 24.4116 21.0205 24.2435 20.4779 23.9407V23.9927C20.4783 24.8949 20.7903 25.7692 21.3612 26.4677C21.9322 27.1662 22.7269 27.6459 23.6109 27.8257C23.2749 27.9172 22.9282 27.9632 22.5799 27.9627C22.3346 27.9628 22.0898 27.9393 21.8489 27.8927C22.0991 28.67 22.5858 29.3497 23.2411 29.8368C23.8964 30.324 24.6876 30.5942 25.5039 30.6097C24.1172 31.6964 22.4057 32.2856 20.6439 32.2827C20.3321 32.2832 20.0206 32.2652 19.7109 32.2287C21.5006 33.3787 23.5837 33.9887 25.7109 33.9857C27.175 33.9956 28.6265 33.7145 29.981 33.1587C31.3356 32.603 32.5663 31.7836 33.6015 30.7484C34.6368 29.7131 35.4561 28.4824 36.0119 27.1279C36.5677 25.7733 36.8488 24.3218 36.8389 22.8577C36.8389 22.6877 36.8389 22.5197 36.8279 22.3517C37.5937 21.7984 38.2547 21.113 38.7799 20.3277L38.7789 20.3267Z",
    fill: "#5044E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8593_1250",
    x: 0,
    y: 0,
    width: 58.4766,
    height: 58.48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8593_1250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8593_1250",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.2b3a2a5681d7add24b875e48c759832a.svg";
export { ForwardRef as ReactComponent };